import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function AssignmentSubmissionsPage() {
  return <InstituteCrudPage config={entityConfigs['assignment-submissions']} />;
}
